<template>
  <footer class="font-14p">
      <div class="container text-center text-md-left">
        <div class="row">
          <div
            v-for="section in sections"
            v-bind:key="section.title"
            :class="`col-md-${section.cols}`"
          >
            <h2 class="font-weight-bold text-uppercase mt-3 font-14p">{{ section.title }}</h2>
            <ul class="list-unstyled text-uppercase">
              <li
                v-for="(item, idx) in section.items"
                v-bind:key="idx"
              >
                <a :href="item.link">{{item.text}}</a>
              </li>
            </ul>
          </div>


          <div class="col-md-4 mx-auto">
            <div class="mt-3">
              <p>© {{ year }} Anchor Loans Inc. All Rights Reserved.</p>
              <p>
                By accessing this site, you agree to be bound
                by our <a href="https://www.anchorloans.com/privacy-policy" target="_blank">Privacy Policy</a>
                &amp; Promotions.
              </p>
            </div>
            <ul class="list-unstyled list-inline social-list">
              <li
                v-for="(item, idx) in social"
                v-bind:key="idx"
                class="list-inline-item"
              >
                <a :class="`btn-floating ${item.class} btn-li mx-1`"
                  target="_blank"
                  :href="item.link"
                >
                  <font-awesome-icon
                    :title="item.title"
                    :icon="['fab', item.icon]"
                    class="floating-icon"/>
                </a>
              </li>
              <li class="list-inline-item">
                <b-img
                  width="35%"
                  src="./static/base/inc-5000.png"
                  v-b-tooltip.hover
                  :title="inc5000.title"
                  :alt="inc5000.alt"
                />
              </li>
            </ul>
            <div>
            </div>
          </div>
        </div>
      </div>
  </footer>
</template>


<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebook, faTwitter, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';

import DATA from './resources';

library.add(faFacebook, faTwitter, faInstagram, faLinkedin);

export default {
  data() {
    return DATA;
  },
  computed: {
    year() {
      const now = new Date();
      return now.getFullYear();
    },
  },
};
</script>

<style scoped>
footer {
  background-color: #343a40 !important;
  border-top: 2px solid #1d87b9;
  color: white;
  margin-top: 45px;
}

a {
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
}

a:focus, a:hover {
  color: rgba(255, 255, 255, 0.75);
}

.btn-floating {
    -webkit-box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
    box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
    width: 37px;
    height: 37px;
    position: relative;
    z-index: 1;
    vertical-align: middle;
    display: inline-block;
    overflow: hidden;
    -webkit-transition: all .2s ease-in-out;
    -o-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
    margin: 10px;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    padding: 0;
    cursor: pointer;
}

.btn-floating:hover {
    -webkit-box-shadow: 0 8px 17px 0 rgba(0,0,0,.2), 0 6px 20px 0 rgba(0,0,0,.19);
    box-shadow: 0 8px 17px 0 rgba(0,0,0,.2), 0 6px 20px 0 rgba(0,0,0,.19);
}

.btn-floating .floating-icon {
    display: inline-block;
    width: inherit;
    text-align: center;
    color: #fff;
    font-size: 1rem;
    margin-top: 10px;
}

.btn-facebook {
  background-color: #3b5998 !important;
}

.btn-linkedin {
  background-color: #0082ca !important;
}

.btn-twitter {
  background-color: #55acee!important;
}

.btn-instagram {
  background-color: #e56969 !important;
}

.social-list {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/base/footer/AnchorFooter.vue